import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useKeyboardStore = defineStore('keyboardStore', () => {
  // State to track if the Ctrl key is pressed
  const isCtrlPressed = ref(false)

  // Function to set the Ctrl key state
  function setCtrlPressed(value) {
    isCtrlPressed.value = value
  }

  return {
    isCtrlPressed,
    setCtrlPressed,
  }
})
